import { B4CA_PhaseDEBRF } from "./B4CA_data_PhaseDEBRF";
import { B4CA_PhaseIE } from "./B4CA_data_PhaseIE";
import { B5CA_PhaseDEBRF } from "./B5CA_data_PhaseDEBRF";
import { B5CA_PhaseIE } from "./B5CA_data_PhaseIE";
import { C5CA_PhaseDEBRF } from "./C5CA_data_PhaseDEBRF";
import { C5CA_PhaseIE } from "./C5CA_data_PhaseIE";
import { SC8CP_PhaseDEBRF } from "./SC8CP_DEBR_Data";
import { SC8CP_PhaseIE } from "./SC8CP_data_PhaseIE";

const GENERIC_STEP_D = {
  title: "Define Rules:",
  text: [
    "The purpose of this debriefing is to reflect on the scenario you have just completed in order to help you improve your skills as a paramedic.  It is not meant to assess your overall abilities as a paramedic.",
    "This debriefing will summarize the learning objectives of this scenario and the performance benchmarks (standards) for achieving each objective.  The system will then prompt you to examine differences between the treatment actions that you performed and those indicated by the clinical findings revealed during the scenario, or that would have been revealed by a more thorough assessment and reassessment of this patient.  Finally, it will prompt you to state some 'take home points' to improve your performance.",
  ],
};

const GENERIC_STEP_F = {
  title: "Formalize learning",
  heading: "Please take a few minutes to reply to these questions",
  questions:
    "What are your key take-home points from this scenario? What is something you want to continue working on or do differently in the future?",
};

function getStep(stepsArray, stepName) {
  if (!stepsArray) {
    return null;
  }
  return stepsArray.find((e) => e.step === stepName) || null;
}

function createScenarioData(ebrData = null, ieData = null) {
  return {
    D: GENERIC_STEP_D,
    E: getStep(ebrData, "E"),
    B: getStep(ebrData, "B"),
    R: getStep(ebrData, "R"),
    IE: ieData,
    F: GENERIC_STEP_F,
  };
}



export function getScenarioFeedback(scenName) {
  switch (scenName) {
    case "B4CA":
      return createScenarioData(B4CA_PhaseDEBRF, B4CA_PhaseIE)
    case "B5CA":
      return createScenarioData(B5CA_PhaseDEBRF, B5CA_PhaseIE)
    case "C5CA":
      return createScenarioData(C5CA_PhaseDEBRF, C5CA_PhaseIE)
    case "SC8CP":
      return createScenarioData(SC8CP_PhaseDEBRF, SC8CP_PhaseIE)
    default:
      return {};
  }
}
